<template>
  <div class="hello">
    <router-link :to="{ path: '/category' }">
      <h1 class="has-text-weight-semibold">{{ category_name }}</h1>
    </router-link>

    <ul>
      <li v-for="book in books" v-bind:key="book.id">
        <BookCard :book_id="book"></BookCard>
      </li>
    </ul>
  </div>
</template>

<script>
import BookCard from "./BookCard.vue";

import BasicAPIs from "@/api/apis";
export default {
  name: "CategoryCard",
  components: {
    BookCard
  },
  props: {
    category_name: String,
    book_n: {
      type: Number,
      default: 4
    }
  },
  data() {
    return {
      books: []
    };
  },
  mounted() {
    let vm = this;
    BasicAPIs.getCategory(vm.category_name).then(res => {
      let books = res.data.msg.category_info;
      vm.books = books.slice(0, vm.book_n);
      return true;
    });
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: block;
  margin: 0 10px;
}
</style>
